<template>
    <div style="background:white" class="ve-list-page">
        <div style=" background:white;line-height:30px;height:40px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1500px; ">
                <el-popover placement="top-start"  :title="$LANG('0872', '状态说明')" width="330" trigger="hover" >
                    <p style="color:#409eff"> {{ $LANG('1922', '1、已确认：表示采购已确认,供应商可以报价') }}</p>
                    <p style="color:#409eff"> {{ $LANG('1503', '2、关闭：表示询价人对供应商报价已决策选中，此时单据已关闭，供应商不能报价了') }}</p>
                    <span slot="reference"><i class="iconfont icon-tishi" style="color:green;font-weight:700;font-size:24px"></i></span>
                </el-popover>
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;font-weight:600"></i>
                <el-link :disabled="addBool" @click="addRec" :underline="false"  ><span style="font-size:12px;margin-right:15px;font-weight:600;white-space:nowrap;">{{ $LANG('0138', '新增') }} </span></el-link>
 
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" filterable  style="width:150px; " >
                    <span v-for="item in tabArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="inputQry" ></el-button>
                </el-input>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
 
            </div>
        </div>  
        <div style="width:100%" class="ve-list-page__body">
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol" 
                    :table-data="tabData" 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:0px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="tabHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"     
                          
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"                    
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false,}"
                    id="po_ask"
                    ref="tableRef" >
 
            </ve-table>
            </div>
            <div style="margin-top:2px" class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="prcRow" :label-width="110"   label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabArr" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="small" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="prcRow[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="small" :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="prcRow[item.key]" style="width:100%" ></el-input-number>  
                            <el-select size="small" filterable v-else-if="item.key==='STAFFNM'" :disabled="saveFlag" style="width:100%" v-model="prcRow[item.key]">
                                <el-row v-for="(item,index) in empArr " :key="index">
                                    <el-col :span="6">
                                        <el-option  :label="item.EMPNO" :value="item.USERNM"></el-option>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-option  :label="item.DEPTNM" :value="item.USERNM"></el-option>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-option  :label="item.USERNM" :value="item.USERNM"></el-option>
                                    </el-col>
                                </el-row>
                            </el-select> 
                            <el-input size="small" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="prcRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div class="one-toolbar">
                    <span class="spanRow"> {{ $LANG('1755', '1、请选择报价供应商') }} </span>
                    【
                    <i class="iconfont icon-xinzeng" style="color:white;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool||saveFlag" @click="addSup" :underline="false" style="color:white"><span style="font-size:13px;margin-right:15px;">{{ $LANG('1103', '新增供应商') }}</span></el-link>
                    】
                </div>
                <el-table  :data="supData" 
                    border                            
                    size="small"
                    :height="200" 
                    :cell-style="{padding:'2px'}"
                    :row-key="getSupKey"
                    ref="refsup"
                    class="custom-table-border"
                    style="margin-top:-9px"
                    highlight-current-row> 
                    <el-table-column :label="$LANG('0310', '序号')" type="index" fixed></el-table-column>
                    <span v-for="(item,index ) in supCol" :key="index" > 
                        <el-table-column  v-if="item.thide==='N'&&item.edcss!=='checkbox'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                        <el-table-column  v-if=" item.edcss=='checkbox'"
                            :prop="item.key"
                            :label="item.title"
                            align="center"                                  
                            width="80">
                            <template slot-scope="scope" >
                                <el-checkbox disabled false-label="N" true-label="Y" v-model="scope.row[item.key]" >&nbsp;</el-checkbox>
                            </template>
                        </el-table-column>
                    </span> 
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="120">
                        <template slot-scope="scope">
 
                            <i class="iconfont icon-bianji" style=" font-size:12px;margin-right:5px; "></i>
                            <el-link :disabled=" saveFlag" @click="supEdit(scope.row,scope.$index)" :underline="false" ><span style="font-size:12px; ">{{ $LANG('1639', '编辑') }}</span></el-link>
                            <i class="iconfont icon-shanchu" style=" font-size:12px;margin-right:5px;margin-left:5px "></i>
                            <el-link :disabled="saveFlag" @click="supDel(scope.row,scope.$index)" :underline="false" ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>
                <div class="one-toolbar">
                    <span class="spanRow">2、{{ $LANG('1740', '请选择询价产品') }}</span>
                    【
                        <i class="iconfont icon-xinzeng" style="color:white;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool||saveFlag" @click="addProduct" :underline="false" style="color:white"><span style="font-size:13px;margin-right:15px;">{{ $LANG('0176', '新增产品') }}</span></el-link>
                    】
                    <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                    <el-select v-model="selparam3" size="small" :placeholder="$LANG('1675', '请选择列名')" clearable  style="width:150px; " >
                        <span v-for="item in matCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key"></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="input_hold" v-model="txtparam3" @keyup.enter.native="matQry" size="small" style="width:320px;margin-left:4px;height:30px; ">
                        <el-select v-model="oper3" slot="prepend"   style="width:100px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="matQry" ></el-button>
                    </el-input>
                    <el-button :disabled="addBool||saveFlag" style="margin-left:15px" size="mini" type="primary" icon="iconfont icon-daochu" @click="impBom">{{ $LANG('0167', '导入单层') }}BOM</el-button>
                    <el-button :disabled="addBool||saveFlag" style="margin-left:15px" size="mini" type="primary" icon="iconfont icon-daochu" @click="impTree">{{ $LANG('0170', '导入树状') }}BOM</el-button>
                    <el-button :disabled="addBool||saveFlag" style="margin-left:15px" size="mini" type="warning" icon="iconfont icon-shanchu" @click="delAll">{{ $LANG('0213', '删除所有产品') }}</el-button>
                    <el-button :disabled="addBool||saveFlag" style="margin-left:15px" size="mini" type="warning" icon="iconfont icon-shanchu" @click="delOk">{{ $LANG('2043', '清除所有选中') }}</el-button>
                </div>
                <el-table  :data="matData" 
                    border                            
                    size="small"
                    :height="300" 
                    :cell-style="{padding:'2px'}"
                    :row-key="getMatKey"
                    :row-class-name="tabRowClass"
                    cell-class-name="clearPadding"
                    @row-click="rowClick"
                    ref="refmat"
                    class="custom-table-border"
                    style="margin-top:-9px"
                    highlight-current-row > 
                    <el-table-column :label="$LANG('0310', '序号')" type="index" ></el-table-column>
                    <el-table-column  v-for="(item ,index) in matCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        sortable
                        :min-width="item.width">
                        <template slot-scope="scope" >
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >
                                <el-input type="number" @keydown.native="e=>e.returnValue=(['e','E','+','-'].includes(e.key))?false:e.returnValue" @keyup.down.native="nextLine(item.key,'down')" @keyup.up.native="nextLine(item.key,'up')"  :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter')"  size="mini" v-if="item.edcss=='number'" :controls="false"  v-model="scope.row[item.key]" style="width:100%"> </el-input>                                             
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                        </template>
                    </el-table-column>                   
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="165">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style=" font-size:12px;margin-right:5px; "></i>
                            <el-link :disabled=" saveFlag" @click="matEdit(scope.row,scope.$index)" :underline="false" ><span style="font-size:12px; ">{{ $LANG('1639', '编辑') }}</span></el-link>
                            <i class="iconfont icon-shanchu" style=" font-size:12px;margin-right:5px;margin-left:5px "></i>
                            <el-link :disabled="saveFlag" @click="matDel(scope.row,scope.$index)" :underline="false" ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span></el-link>
                            <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-left:5px; "></i>
                            <el-link :disabled="!saveFlag" @click="addQuote(scope.row)" :underline="false" ><span style="font-size:12px; ">{{ $LANG('0180', '新增报价') }}</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>
                <div class="one-toolbar">
                    <span class="spanRow"> 3、{{ $LANG('1357', '供应商报价明细') }}</span>

                </div>
                <el-table  :data="prcData" 
                    border                            
                    size="small"
                    :height="260" 
                    :cell-style="{padding:'2px'}"
                    :row-key="getPrcKey"
                    ref="refprc"
                    style="margin-top:-9px"
                    class="custom-table-border"
                    highlight-current-row> 
                    <el-table-column :label="$LANG('0310', '序号')" type="index" fixed></el-table-column>
                    <span v-for="(item,index ) in prcCol" :key="index" > 
                        <el-table-column  v-if="item.thide==='N'&&item.key!=='ISOK'"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                        <el-table-column  v-if=" item.key==='ISOK'"
                            :prop="item.key"
                            :label="item.title"
                            align="center"                                
                            width="80">
                            <template slot-scope="scope" >
                                <el-checkbox disabled false-label="N" true-label="Y" v-model="scope.row.ISOK" >&nbsp;</el-checkbox>
                            </template>
                        </el-table-column> 
                    </span> 
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="160">
                        <template slot-scope="scope">
 
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                            <el-link @click="prcDel(scope.row,scope.$index  )"  :underline="false"  ><span style="font-size:12px;margin-right:6px;">{{ $LANG('0131', '删除') }} </span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                            <el-link @click="prcUndo(scope.row,scope.$index  )" :disabled="scope.row['ISOK']!=='Y'" :underline="false"  ><span style="font-size:12px;margin-right:5px;">{{ $LANG('0315', '弃选') }} </span></el-link>
                            <i class="iconfont icon-chenggong" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                            <el-link @click="prcEdit(scope.row,scope.$index  )"  :underline="false"  ><span style="font-size:12px;margin-right:2px;">{{ $LANG('1956', '选中') }} </span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">              
                    <el-button v-if="prcRow['STFG']==='NO'" size="mini"    type="primary" icon="iconfont icon-chenggong1" @click="stfgAmend('OK')" style="margin-right:20px;">{{ $LANG('0954', '询价确认') }}</el-button>
                    <el-button v-if="prcRow['STFG']==='OK'" size="mini"    type="primary" icon="iconfont icon-chexiao_icon" @click="stfgAmend('NO')" style="margin-right:20px;">{{ $LANG('1139', '询价反确认') }}</el-button>
                    <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600"> {{ $LANG('1498', '提示：产品关闭后不能再编辑 , 如需编辑请反关闭') }}</i>
                    <i v-if="prcRow['STFG']==='NO'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weiqueren"> </i>
                    <i v-else-if="prcRow['STFG']==='OK'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yiqueren"> </i>
                    <i v-else-if="prcRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    <i v-else-if="prcRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yiguanbi"> </i>
                    <i v-else-if="prcRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;margin-left:30px">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="addBool||saveFlag"  type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" v-if="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"   v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog> 
        <el-dialog  v-dialogDrag  v-if="treeWin" :visible.sync="treeWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <main-second v-bind:tabCol ="tableCol"   v-bind:v_table="v_table" v-bind:dtlCol="dtlCol" v-bind:dtlTable="dtlTable" @child-exit="treeWin=false" @child-sure="treeSure"></main-second>                
        </el-dialog>
        <!-- 新增供应商资料 -->
        <el-dialog   class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="supAdd" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1103', '新增供应商') }}</span>
            </div> 
            <div style="display:flex;margin-bottom:20px;">
                <div style="line-height:40px;width:110px;">{{ $LANG('1062', '供应商类别') }}</div>
                <el-select filterable v-model="v_supty"  @change="getSupRec" style="width:350px">
                    <span v-for="item in suptyArr" :key='item.CODE'>
                        <el-option :label="item.CNAME" :value="item.CODE"></el-option>
                    </span>
                </el-select>
            </div>
            <div style="display:flex;margin-bottom:20px;">
                <div style="line-height:40px;width:110px;">{{ $LANG('1060', '供应商名称') }}</div>
                <el-select filterable  v-model="v_supno" style="width:350px" @change="supChg">
                    <span v-for="(item ,index) in supOption" :key='index'>
                        <el-option :label="item.SUPNM" :value="item.IDSEQ"></el-option>
                    </span>
                </el-select>
            </div>
            
            <div style="display:flex;margin-bottom:20px;">
                <div style="line-height:40px;width:110px;">{{ $LANG('0294', '备注') }}</div>
                <el-input  type="text"   v-model="v_rmk" style="width:350px"></el-input>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="supExit" style="margin-right:25px;margin-left:30px">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled=" saveFlag"  type="primary" size="small" icon="iconfont icon-chenggong1"  @click="supAppend" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 商品明细新增 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="prdWin" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{prdFlag==='create'?$LANG('0178', '新增商品'):$LANG('0917', '编辑商品')}}</span>
            </div> 
            <Form :model="prdRow" :label-width="120" ref="dtlForm"  label-position="right" inline  :rules="ruleValidate">  
                <span v-for="(item,index) in matCol" :key="index" >
                    <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <el-date-picker  type="date"  v-if="item.edcss==='date'" v-model="prdRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                        <el-input-number :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="prdRow[item.key]" style="width:100%"></el-input-number> 
                        <el-checkbox border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="prdRow[item.key]" style="width:100%"></el-checkbox> 
                        <el-input  type="text" disabled v-model="prdRow[item.key]" v-else-if="item.key==='MATNO'">
                            <el-button style="color:#409eff" slot="append" icon="iconfont icon-gengduo" @click="inputBtn" ></el-button>
                        </el-input>
                        <el-select v-model="prdRow[item.key]"  v-else-if="item.key==='MATTY'"   style="width:100%">
                            <el-option :label="$LANG('0424', '产成品')" value="PRD"></el-option>
                            <el-option :label="$LANG('0443', '原材料')" value="MAT"></el-option>
                            <el-option :label="$LANG('1798', '样板-模具-设计服务')" value="SMP"></el-option>
                        </el-select>
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="prdRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" icon="iconfont icon-shanchu" size="small" @click="prdWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" icon="iconfont icon-baocun" size="small" @click="prdAppend" style="margin-right:10px;">{{ $LANG('1638', '确定') }}</el-button>
                </span>
            </div>
        </el-dialog>
  
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 报价明细新增 -->
        <el-dialog v-dialogDrag :visible.sync="prcWin" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> {{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <Form :model="quoRow" :label-width="120"   label-position="right" inline  >  
                <span v-for="(item,index) in prcCol" :key="index" >
                    <FormItem   :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <template slot="label"><span v-if="item.notnull=='Y'" style="color:red;margin-right:5px">*</span>{{item.title}}</template>
                        <el-date-picker  type="date"  v-if="item.edcss==='date'" v-model="quoRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                        <el-input-number :disabled="item.disabled==='Y'?true:false " :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="quoRow[item.key]" style="width:100%"></el-input-number> 
                        <el-checkbox disabled border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="quoRow[item.key]" style="width:100%"></el-checkbox> 
                        <el-select  v-else-if="item.key==='TAX'"  v-model="quoRow[item.key]"  style="width:100%" filterable>
                            <el-option v-for="(item,index) in taxArr" :key="index" :value="item.SUBNO" :label="item.CNAME" ></el-option>
                        </el-select> 
                        <el-select  v-else-if="item.key==='ADDUSER'"  v-model="quoRow[item.key]"  style="width:100%" filterable>
                            <el-option v-for="(item,index) in supArr" :key="index" :value="item.SUPNM" :label="item.SUPNM" ></el-option>
                        </el-select> 
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false||item.key=='OKRMK' "  v-model="quoRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" icon="iconfont icon-shanchu" size="small"  @click="prcWin=false" style="margin-right:50px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" icon="iconfont icon-chenggong1"  size="small" @click="prcOk" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue' 
import mainSecond from '../datamgt/main_second.vue'  
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
export default {
    name:'po_askprc',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '15992',
            fieldIdseq: '15992',
            fieldLstseq: '1',
            scopeRefItmseq: '900015',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            columnHiddenOptionKey: 'columnHiddenOption',
            lockedFieldKeys: ['SEL'],
        })
    ],
    data () {
        return {
            treeWin:false,
            prcWin:false,
            selparam4:'',
            oper4:'like',
            txtparam4:'',
            quoRow:{},
 
            repWin:false,
            repUrl:'',
 
            prdWin:false,
            promptWin:false,
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
            rowIndex:'',
            v_key:'',
            v_key2 :'',
            v_value2 :'', 
            v_supno:'' ,//供应商编码
            v_supnm:'', //供应商名称
            v_rmk:'', //备注
            v_supty:'',
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            rowSup:{},
            delPrdArr:[],
            stfgSet:'ALL',
            delSupArr:[],
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容...'),
            ruleValidate:{},
            selparam:'IDNO',
            txtparam:'',
            treeCol:[],
            selparam3:'MATNM',
            txtparam3:'',
            oper3:'like',
            prcRow:{},
            prdFlag:'create',
            netCol:[],
            supAdd:false,
            tabData:[],
            cfmBool:false, //关闭 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            delBool:false,
    
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            supData:[],
            matData:[],
            addWin:false,
            v_username :this.$cookies.get('v_telno' ), //用户名称 
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_url:'xuper_auth/getTableRecMany', //api请求路径  
 
            pageList: [50,500,1000], 
            dataCount:0,
            pageSize:50,
            supCol:[],
            matCol:[],
            tabArr:[],
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            selAll:'N',
            dtlData:[],
            v_idseq: '',
            supIndex:'',
            empArr:[],
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            supOption:[],
            suptyArr:[],
            btnWin:false,
            v_table:'',
            tableCol :[],
            dtlCol:[],
            dtlTable:'',
            bomCol:[],
            chkIndex:'',
            nextData:[],
            stkCol:[],
            maxHeight:'',
            supArr:[],
            taxArr:[],
            prodCol:[],
            t_idseq:'',
            initCol:[],
            vueCol:[],
            pageIndex:1,
            loadingInstance: null,
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,                
            }, 
            startRowIndex: 0,
            footerData:[], 
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1"      
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_row:{},
            v_inputrow:{},
            v_sort:'asc',
        }
    },
    components: {
      pubWin,
        mainSecond,
        VeColumnConfigDialog,
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    computed: {
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    mounted () {
        this.showkey()
        this.getSupSel() 
        this.maxHeight = document.documentElement.clientHeight - 560
        getBaseData('xuper_auth/getBaseData','PARENTNO','284','','','v_sys_base','').then(res=>{
            this.suptyArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','PARENTNO','249','','','v_sys_base','').then(res=>{
            this.taxArr =res.result
        })
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','V_SYS_USER','').then(res=>{
            this.empArr =res.result
        })
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','15992','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //关闭
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
    },
    created () {
        if (this.v_username){
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#po_ask"),
                name: "wave",
            })
            this.getTabCol() //表列集合
            this.getTabList('') // 主数据    
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {

        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabArr.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        prcDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此行记录吗,仅删除手工增加的记录'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'],p_key2:'lstseq',p_value2:row['LSTSEQ'],p_key3:'itmseq',p_value3:row['ITMSEQ'], p_table:'po_prc_matdtl' },
                }).then(res=>{
                    this.prcData.splice(index,1)
                })
            }).catch(()=>{})
        },
        prcOk(){
            if (!this.quoRow['TAXPRC']){
                this.promptWin=true
                this.prompt=this.$LANG('0273', '单价') + this.$LANG('2051', '不能为空')
            }else if (!this.quoRow['TAX']){
                this.promptWin=true
                this.prompt=this.$LANG('0368', '税率') + this.$LANG('2051', '不能为空')
            }else if (!this.quoRow['ADDUSER']){
                this.promptWin=true
                this.prompt=this.$LANG('2060', '报价用户') + this.$LANG('2051', '不能为空')
            }else{      
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/tableBodySave2',
                    data: {p_json:JSON.stringify( this.quoRow  ), p_table:'po_prc_matdtl' },
                }).then(res=>{   
                    if(res.code ==='200')  {      
                        this.prcWin=false
                        this.getQuoteList(this.quoRow['IDSEQ'],this.quoRow['LSTSEQ'])
                    }else{
                        this.prompt =res.result
                        this.promptWin=true
                    }        
                })        
            }
        },
        //新增报价明细
        addQuote(row){
            this.prcWin =true
            this.quoRow={MATNM:row['MATNM'],MATDESC:row['MATDESC'],USERNO:this.v_username,IDSEQ:row['IDSEQ'],LSTSEQ:row['LSTSEQ'],ITMSEQ:'' }
        },
 
 
        //查询明细数据
        getDtlData(idseq){
            let cond_=''
            if (this.selparam4){ //列1
                if (this.oper4==='like'){
                    cond_=cond_+' and  '+this.selparam4+'  like  \'%' + this.txtparam4+'%\' '
                }else{
                    cond_=cond_+' and '+this.selparam4  +this.oper4+' \''+this.txtparam4+'\' '
                }
            }
            this.dtlData=[]
            getTabColOrData(this.v_url,'V_PO_PRC_NEXT','idseq',idseq,'','','','',cond_).then((res) => {    
                this.dtlData =res.result  
 
            })
        },
        qryDtl(){
            if (this.v_idseq){
                this.getDtlData(this.v_idseq)
            }
        },
        selEvent(){
            this.dtlData.forEach(item=>{
                item['SEL']=this.selAll
            })
        },
 
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
         //表格行 按回车键 到下一行
        nextLine(key,val ){ 
             if (val =='down'){
                this.chkIndex = this.chkIndex +1                    
                if (key =='POQTY'){
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])      
                    if (this.chkIndex >=this.dtlData.length) {
                        this.chkIndex =0
                    }     
                }else{
                    this.$refs['refmat'].setCurrentRow(this.matData[this.chkIndex])   
                    if (this.chkIndex >=this.matData.length) {
                        this.chkIndex =0
                    }         
                }
                this.$refs[this.chkIndex+key][0].focus()             
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }                            
                this.$refs[ this.chkIndex+key][0].focus()  
                if (key =='POQTY'){
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])       
                }else{
                    this.$refs['refmat'].setCurrentRow(this.matData[this.chkIndex])   
                }
            }                    
        },
        rowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            if (row['CNT']==0 ){
                return 'warning-row';
            }else if (row['CNT'] >1 ){
                return 'many-row';
            }else{
                return 'one-row';
            }
        },
        delAll(){
            this.$confirm(this.$LANG('1594', '你确定要删除所有产品记录吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                this.matData.forEach((item,index) =>{
                    this.delPrdArr.push(item)        
                })
                this.matData =[]
            }).catch(err=>{})
        },
        impBom(){
            this.v_key='bom'
            this.v_table ='v_bs_bom'
            this.tableCol =this.bomCol
            this.key2 =''
            this.value2 =''
            this.btnWin =true
        },
        impTree(){
            this.v_key='bom'
            this.v_table ='v_prd_bom'
            this.tableCol =this.treeCol
            this.dtlCol = this.netCol
            this.dtlTable ='V_PRD_BOMNET'
            this.treeWin =true
        },
        btnSure(obj){
            if (this.v_key=='matno'){
                Object.assign(this.prdRow,{MATNO:obj['IDNO'],MATNM:obj['MATNM'] ,MATDESC:obj['MATDESC'],MATTYNM:obj['MATTYNM'] }) 
            }else{
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'idseq', p_value:obj['IDSEQ'], p_cond: ' order by PKID' ,p_table:'v_bs_bomdtl'},
                }).then(res=>{
                    res.result.forEach(item =>{
                        let obj ={'MATNO':item['MATNO'],'MATNM':item['MATNM'],'MATTYNM':item['MATTYNM'],MATDESC:item['SPECNM'],UNITNM:item['UNITNM']}
                        this.matData.push(obj)
                    })    
                })  
            }
            this.btnWin =false
        },
        //树状bom 选择记录 确定
        treeSure(obj){
            obj.forEach(item =>{
                let v_bool =true
                this.matData.some(it=>{
                    if (it['MATNO']==item['MATNO']){
                        v_bool =false
                    }
                })
                if (v_bool) {
                    let obj ={'MATNO':item['MATNO'],'MATNM':item['MATNM'],'MATTYNM':item['MATTYNM'],MATDESC:item['MATDESC'],UNITNM:item['UNITNM']}
                    this.matData.push(obj)
                }
            })    
            this.treeWin =false
            this.$refs['refmat'].doLayout()
        },
        repBtn(row){
            this.repWin =true
            this.repUrl =this.$store.state.repUrl+'po_ask.cpt&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
        },
        getSupRec(){          
            getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'supty',this.v_supty,'v_bs_sup','').then(res=>{
                this.supOption =res.result
                this.v_supno=''
            })
        },
        getSupSel(){          
            getBaseData('xuper_auth/getBaseData','CORPID',this.v_corpid ,'','','v_bs_sup','').then(res=>{
                this.supOption =res.result
            })
        },
        delOk(){
            this.$confirm(this.$LANG('1624', '你确定要清除所有产品的选中记录吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                this.$axios({
                    method: 'post',
                    url: 'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:this.t_idseq ,p_table:'po_prc_matdtl',p_cond:' set isok=\'N\'' },
                }).then(res=>{ 
                    this.$message({message: this.$LANG('2027', '已执行完成'),type: 'success',center:true,duration:2000})
                })
            }).catch(err=>{})
        },
        prcEdit(row,index ){
            let vm =this
            //先置于全部 为 未选中 ，然后再更新当前记录为选中
            this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:row['IDSEQ'],p_key2:'lstseq',p_value2:row['LSTSEQ'],p_table:'po_prc_matdtl',p_cond:' set isok=\'N\'' },
            }).then(res=>{      
                this.prcData.forEach(item=>{
                    Object.assign(item,{ISOK:'N'})
                }) 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'],p_key2:'lstseq',p_value2:row['LSTSEQ'],
                        p_key3:'itmseq',p_value3:row['ITMSEQ'],p_table:'po_prc_matdtl',p_cond:' set isok=\'Y\'' },
                }).then(res=>{          
                    this.prcData.splice(index,1,Object.assign(row,{ISOK:'Y'}))
                })      
            })
        },
        prcUndo(row,index ){
            let vm =this
 
            if (row['ISOK']=='Y') {
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'],p_key2:'lstseq',p_value2:row['LSTSEQ'],
                        p_key3:'itmseq',p_value3:row['ITMSEQ'],p_table:'po_prc_matdtl',p_cond:' set isok=\'N\'' },
                }).then(res=>{          
                    this.prcData.splice(index,1,Object.assign(row,{ISOK:'N'}))
                })      
            }
        },
        //报价明细 
        getQuoteList(idseq,lstseq){
            getTabColOrData(this.v_url,'v_po_prc_matdtl','idseq',idseq,'lstseq',lstseq,'','','' ).then((res) => { 
                this.prcData =res.result 
            })
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refprc.doLayout();
            }) 
        },
        //产品选择确认
        prdAppend(){
            if(!this.prdRow['MATNO']){
                this.promptWin=true
                this.prompt=this.$LANG('0657', '商品编码') + this.$LANG('2051', '不能为空')
            }else if(!this.prdRow['QTY']){
                this.promptWin=true
                this.prompt=this.$LANG('0391', '询价') + this.$LANG('0333', '数量') + this.$LANG('2051', '不能为空')
            }else{
                if (this.prdFlag==='create'){
                    this.matData.push(this.prdRow)
                }else{
                    this.matData.splice(this.prdIndex,1, this.prdRow )
                }
                this.prdWin=false
            }
        },
        inputBtn(){
            this.v_key='matno'
            this.v_table ='v_bs_mat'
            this.tableCol =this.prodCol
            this.v_key2 ='modelno'
            this.v_value2 = this.prdRow['MATTY']
            this.btnWin =true
        },
        addProduct(){
            this.prdWin=true
            this.prdFlag='create'
            this.prdRow={MATTY:'PRD'}
        }, //matno,matnm,matdesc,unit,prc
 
        matEdit(row,index){
            this.prdRow=JSON.parse(JSON.stringify(row))
            this.prdWin=true
            this.prdFlag='edit'
            this.prdIndex=index 
            this.delPrdArr =[] 
        },
        matDel(row,index){
            this.delPrdArr.push(row)
            this.matData.splice(index,1 )
        },
        //供应商明细编辑、删除
        supDel(row,index){
            this.delSupArr.push(row)
            this.supData.splice(index,1 )
        },
        supEdit(row,index){
            this.v_supno=row['SUPNO']
            this.v_rmk =row['RMK']
            this.v_supty=row['SUPTY']
            this.rowSup=row 
            this.supAdd=true
            this.supFlag='edit'
            this.supIndex=index 
            this.delSupArr =[] 
        },
        supChg(val){
            this.supOption.some(item=>{
                if (item['IDSEQ']==val)
                  this.v_supnm =item['SUPNM']
            })
        },
        supExit(){
            this.supAdd=false
            this.getSupSel()
        },
        //供应商选择确认
        supAppend(){
            if(!this.v_supno){
                this.promptWin=true
                this.prompt=this.$LANG('1063', '供应商编码') + this.$LANG('2051', '不能为空')
            }else{
                if (this.supFlag==='create'){
                    this.supData.push({SUPNO:this.v_supno, SUPNM:this.v_supnm,RMK:this.v_rmk,SUPTY:this.v_supty})
                }else{
                    this.supData.splice(this.supIndex,1,Object.assign(this.rowSup,{SUPNO:this.v_supno, SUPNM:this.v_supnm,RMK:this.v_rmk,SUPTY:this.v_supty}) )
                }
                this.supAdd=false
                this.getSupSel()
            }
        },
        addSup(){
            this.supFlag='create'
            this.supAdd=true
            this.v_rmk=''
            this.v_supno=''
            this.delSupArr=[]
        },
        refresh(row){
            this.$confirm( '你确定要刷新选中物料的询价供应商吗?' ,  '提示' ,{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                const payload = {corpid:this.v_corpid,p_idseq:row['IDSEQ'],p_action:'POASK_REF#' ,p_user:this.v_username,p_rmk:''}
 
                this.$axios({
                    method: 'post',
                    url:'/xuper_oss/call_package',
                    data: payload,
                }).then(res=>{
                    if (res.code!=='200'){
                        this.promptWin =true
                        this.prompt =res.result
                    }else{
                        this.$message({ message: '已刷新',type: 'success'})
                    }
                })
            }).catch(()=>{})
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
                getTabColOrData(this.v_url,'V_PO_PRC_sup','idseq',row['IDSEQ'],'','','','','').then((res) => {    
                    this.supArr =res.result  
                })
            }else{            
                if (row.STFG==='Y'||row.STFG==='OK'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.rowIndex =index
            this.addFlag='edit'
            this.prcRow =JSON.parse(JSON.stringify(row))
            //供应商数据
            this.getSupList(row.IDSEQ)
            //商品数据
            this.getMatList(row.IDSEQ,'')
            this.t_idseq =row.IDSEQ
            this.addWin=true      
        },
        //保存记录
        saveRec(){
            if (!this.prcRow['PODTTM']) {
                this.promptWin=true
                this.prompt=this.$LANG('2061', '询价日期') + this.$LANG('2051', '不能为空')
            }else{  
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.prcRow,{'CORPID':this.v_corpid})), p_table:'po_prc',frmid:'15992'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_ =res.idseq
                        //1、供应商 批量保存   
                         this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.supData), p_table:'po_prc_sup',p_idseq:idseq_,p_action:'S' },
                         }).then(res=>{
                             if (res.code!=='200'){
                                 this.promptWin=true
                                 this.prompt=res.result
                             }
                         })
                         //供应商删除
                         if (this.delSupArr.length>0) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delSupArr), p_table:'PO_PRC_SUP',p_idseq: idseq_,p_action:'D' },
                            })
                         }    
                         //2、商品保存：批量保存  res.idseq
                         this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.matData), p_table:'po_prc_mat',p_idseq:idseq_,p_action:'S' },
                         }).then(res=>{
                             if (res.code!=='200'){
                                 this.promptWin=true
                                 this.prompt=res.result
                             }
                         })
                         //商品删除    
                         if (this.delPrdArr.length>0) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delPrdArr), p_table:'PO_PRC_mat',p_idseq: idseq_,p_action:'D' },
                            })
                         }      
                        this.addWin =false   
                        this.getTabList('')
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
 
        },
        //新增
        addRec(){
            this.addWin=true
            this.supData=[]
            this.matData =[]
            this.prcData =[]
            this.saveFlag =false
            this.prcRow={PODTTM:getDate('day'),STFG:'NO',STAFFNM:this.v_usernm,}
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.ORDSTFG  === 'Y') {
                return 'success-row';
            } else if (row.ORDSTFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getRowClick(row){
            this.chkIndex =row.index
        },
        getDtlKey(row){
            return row.index
        },
        getSupKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        getMatKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        getPrcKey(row){
            if (row.IDSEQ && row.LSTSEQ&&row.ITMSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ+'-'+row.ITMSEQ
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.v_inputrow={}
            this.inputQry()
        } ,
        //删除单据
        delRec(row){
            let cond_=''
            if (this.selparam){
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%'+this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam+this.oper+'\''+this.txtparam+'\''
                }
            }
 
            this.$confirm(this.$LANG('1594', '你确定要删除此行单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                let vm =this
                //1. 先删除报价记录
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'po_prc_matdtl' },
                }).then(res=>{      
                    if(res.code =='200')  {           
                        this.$axios({ // 2. 删除询价 物料
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'po_prc_mat' },
                        }).then(res=>{ 
                            if(res.code =='200')  {  
                                this.$axios({ // 3. 删除询价供应商
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'po_prc_sup' },
                                }).then(res=>{ 
                                    if(res.code =='200')  { 
                                        this.$axios({ // 4. 删除询价单
                                            method: 'post',
                                            url:'xuper_auth/delTabRec',
                                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'po_prc' },
                                        }).then(res=>{ 
                                            this.getTabList(cond_)
                                        })
                                    }
                                })
                            }
                        })
                    }      
                })
            }).catch(()=>{})
        },
        //状态作废
        stfgRec(row,val,index){
            let v_comm='',cond_='',v_dttm=''
            if (val==='Y'){
                v_comm=this.$LANG('1945', '关闭')
                v_dttm =getDate('full')
                cond_=' set stfg=\''+val+'\' , okdttm=\''+v_dttm+'\',UPDDTTM=\''+getDate('full')+'\',upduser=\''+this.v_usernm+'\''
            }else if (val==='X'){
                v_comm=this.$LANG('0131', '删除')
                cond_=' set stfg=\''+val+'\' , OKdttm=null,UPDDTTM=\''+getDate('full')+'\',upduser=\''+this.v_usernm+'\''
            }else if (val==='OK'){
                v_comm=this.$LANG('0313', '弃关')
                v_dttm =''
                cond_=' set stfg=\''+val+'\' , OKdttm=null,UPDDTTM=\''+getDate('full')+'\',upduser=\''+this.v_usernm+'\'' 
            }
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'po_prc',p_cond: cond_},
                }).then(res=>{      
                    if(res.code =='200')  {     
                        if (val=='X'){
                            this.tabData.splice(index,1)
                        } else {   
                            Object.assign(row,{STFG:val,OKDTTM:v_dttm })
                        }
                    }else{
                        this.promptWin =true
                        this.prompt=res.result
                    }        
                })
            }).catch(()=>{})
             
        },
        //状态变更
        stfgAmend(val){
            let v_comm='',cond_='' ,v_dttm=''
            if (val==='OK'){
                v_comm=this.$LANG('0364', '确认')
                v_dttm =getDate('full')
                cond_=' set stfg=\''+val+'\' , cfmdttm=\''+v_dttm+'\''
            }else if (val==='NO'){
                v_comm=this.$LANG('0314', '弃认')
                v_dttm =''
                cond_=' set stfg=\''+val+'\' , cfmdttm=null' 
            }   
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:this.prcRow['IDSEQ'],p_table:'po_prc',p_cond:cond_},
                }).then(res=>{      
                    if(res.code =='200')  {           
                       // Object.assign(this.prcRow,{STFG:val })
                        this.tabData.splice(this.rowIndex,1,Object.assign(this.prcRow,{STFG:val ,CFMDTTM:v_dttm}))
                        this.addWin =false
                    }else{
                        this.promptWin =true
                        this.prompt=res.result
                    }        
                })
            }).catch(()=>{})
          
        },
        // 行点击事件
        rowClick(row){
            this.chkIndex =row.index
            //明细查询
            this.getQuoteList(row.IDSEQ,row.LSTSEQ)
        },
        matQry(){
            let cond_=''
            if (this.selparam3){
                if (this.oper3==='like'){
                    cond_=cond_+' and '+this.selparam3+' like \'%'+this.txtparam3+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam3+this.oper3+'\''+this.txtparam3+'\''
                }
            }
            if (this.prcRow && this.prcRow['IDSEQ'])
            this.getMatList(this.prcRow['IDSEQ'],cond_)
        }, 
    
        //表格页面导航
        changePage(index){
  
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex =index
            this.tabData = this.allList.slice(_start,_end)
        },
        //初始化查询页条数
        initPage(){
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.pageSize){
                this.tabData = this.allList          
            }else{
                this.tabData =this.allList.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素            
            }
        },
        //字段查询
        inputQry(){
            let v_cond ='' , v_oper='=' ,v_oper2='like' ,v_edcss=''
            if (this.selparam && this.txtparam){ //列1
                this.tabArr.some(item=>{  
                    if (item['key']==this.selparam){
                        v_edcss =item['edcss']
                    }
                })
                if (this.oper==='like'){
                    v_cond=v_cond+' and  '+this.selparam+' like  \'%' + this.txtparam+'%\' '
                } else{
                    if (this.txtparam){
                        if (v_edcss=='number'){
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+ this.txtparam
                        }else {
                            v_cond=v_cond+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                        }
                    }
                }               
            }
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (this.v_row[`#OPER`+item]){
                        v_oper2 =this.v_row[`#OPER`+item]
                    }     
                    if (v_edcss =='number' ){
                        v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                    }else if ( v_edcss=='date'){
                        v_cond =v_cond +' and '+item+ v_oper +'\''+this.v_row[item] +'\''
                    }else{
                        if (v_oper2 =='='){
                            v_cond =v_cond +' and  '+item+' = \''+ (this.v_row[item]).trim()+'\''  
                        }else{
                            v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                        }
                    }
                }
            })
            this.getTabList(v_cond)
        },
        //查询界面
        getTabList(cond){
            let vm =this
            console.log(cond)
            this.loadingInstance.show()    
            getTabColOrData(this.v_url,'v_po_prc','corpid',this.v_corpid,'','','','',cond+' order by '+this.selparam+' desc' ).then((res) => { 
                this.allList =res.result 
                this.initPage() 
                this.$nextTick(() => { // 
                    this.loadingInstance.close() 
                })
            })
        },
        //报价供应商 
        getSupList(idseq){
            getTabColOrData(this.v_url,'v_po_prc_sup','idseq',idseq,'','','','','' ).then((res) => { 
                this.supData =res.result 
                this.$refs['refsup'].doLayout()
            })
        },
        //报价商品 
        getMatList(idseq,cond){
            getTabColOrData(this.v_url,'v_po_prc_mat','idseq',idseq,'','','','',cond ).then((res) => { 
                this.matData =res.result 
                if (res.result.length>0){
                    this.getQuoteList(res.result[0].IDSEQ,res.result[0].LSTSEQ)
                    this.$refs['refmat'].setCurrentRow(res.result[0])
                     this.$refs['refmat'].doLayout()
                }else{
                    this.prcData=[]
                }
            })
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            this.vueCol =[]
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15992','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                const fieldRows = vm.sortFieldRows(vm.initCol)
                vm.tabArr =[]
                vm.vueCol =[]
                for (let k=0; k<fieldRows.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(fieldRows[k], vm.$store.state.lang),
                        key: fieldRows[k].key,
                        align: fieldRows[k].align,
                        width: fieldRows[k].width,
                        edcss: fieldRows[k].EDCSS,
                        thide:fieldRows[k].THIDE,
                        holder:fieldRows[k].HOLDER,
                        fhide:fieldRows[k].FHIDE,
                        disabled:fieldRows[k].DISABLED,
                        dotnum:fieldRows[k].DOTNUM,
                    })
                    let itcol =fieldRows[k]
                    if (itcol['THIDE']=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}, h) => {
                                if (itcol.EDCSS =='date'||itcol.EDCSS =='time') {
                                    return (                              
                                        <div >                   
                                            <div style="margin-top:3px;display:flex;white-space: nowrap;  " >
                                                <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>                                            
                                            </div> 
                                            <div style="display:flex">
                                                <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>                                                    
                                                    <option    value="=" style="height:30px;line-height:30px">=</option>
                                                    <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                    <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                    <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                                </select>
                                                <el-date-picker v-model={this.v_row[column.key]} value-format="yyyy-MM-dd" size="mini"  placeholder="yyyy-mm-dd" style="width:100%" on-change={()=>this.inputQry() }  ></el-date-picker> 
                                                         
                                            </div>
                                        </div>                                   
                                    )
                                } else{
                                    if (itcol.EDCSS =='checkbox') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <el-select  placeholder="请选择"   v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini">
                                                        <el-option label={this.$LANG('2047', '是')} value="Y"></el-option>
                                                        <el-option label={this.$LANG('2044', '否')} value="N"></el-option>
                                                    </el-select> 
                                                </div>
                                            </div>                                   
                                        )
                                    }else if (itcol.key =='STFG') {
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <el-select  placeholder="请选择"   v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini">
                                                        <el-option label={this.$LANG('0321', '所有')} value="ALL"></el-option>
                                                        <el-option label={this.$LANG('2011', '未确认')} value="NO"></el-option>
                                                        <el-option label={this.$LANG('1982', '已确认')} value="OK"></el-option>
                                                        <el-option label={this.$LANG('2002', '未关闭')} value="N"></el-option>
                                                        <el-option label={this.$LANG('1968', '已关闭')} value="Y"></el-option>
                                                        <el-option label={this.$LANG('1964', '已作废')} value="X"></el-option>
                                                    </el-select> 
                                                </div>
                                            </div>                                   
                                        )
                                    } else{
                                        return (                              
                                            <div >
                                                <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                                    <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                                </div>  
                                                <div style="display:flex">
                                                    <el-input  placeholder="请输入"  disabled={itcol.EDCSS=='image'||itcol.key=='SEL'}  v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input> 
                                                </div>
                                            </div>                                   
                                        )
                                    }
                                }
                            },
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.key=='SEL' ){
                                    return ( 
                                        <el-checkbox true-label="Y" disabled={row['STFG']!=='Y'} false-label="N" v-model={row['SEL']}  style="width:100%;"   > </el-checkbox>
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{row['STFGNM']}</el-tag> )
                                    }else if (row[itcol['key']] =='OK'){
                                        return (<el-tag   size="mini" type="primary" effect="dark">{row['STFGNM']}</el-tag> )
                                    }else if (row[itcol['key']] =='NO'){
                                        return (<el-tag   size="mini" type="danger" effect="dark">{row['STFGNM']}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{row['STFGNM']}</el-tag> )
                                    }                                          
                                }else if (column.key=='IDNO') { //procShow(scope.row)
                                    return (
                                        <el-link   on-click={()=>{this.repBtn(row)}}  underline={false} ><span style="font-size:13px;border-bottom:1px solid #409eff;font-weight:700">{row[itcol['key']]}</span></el-link> 
                                    )
                                }else if (itcol.EDCSS=='checkbox' ) {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
 
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "left",
                    fixed:"left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (<span style="color:#1890ff;">
                            {rowIndex + this.startRowIndex + 1}
                        </span> )  
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width: 205,
                    align: "center",
                    fixed:"right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['STFG']=='Y'){
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.stfgRec(row,'OK',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0313', '弃关')}</span></el-link>
                                </div>                                
                            )  
                        }else if (row['STFG']=='OK'){
                            return ( 
                                <div>
                                    <i class="iconfont icon-shuaxin" style="color:#409EFF;font-size:12px; "></i>
                                    <el-link   on-click={()=>{this.refresh(row )}}  underline={false} ><span style="font-size:12px;margin-right:5px;"> 刷新 </span></el-link>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'N',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.stfgRec(row,'Y',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('1945', '关闭')}</span></el-link>
                                </div>                                
                            )  
                        }else if (row['STFG']=='NO'){
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'N',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.stfgRec(row,'X',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0131', '删除')}</span></el-link>
                                </div>                                
                            )  
                        }else{
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'N',rowIndex )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('1639', '编辑')}</span></el-link>
                                </div>                                
                            ) 
                            
                        } 
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                vm.applyFieldSettingRows()
                return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15992','lstseq','3','','',' and thide=\'N\' order by sortby ' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.supCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15992','lstseq','4','','','   order by sortby ' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.matCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15992','lstseq','5','','','   order by sortby ' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.bomCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15992','lstseq','2','','',' and thide=\'N\' order by sortby ' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prcCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15992','lstseq','6','','',' and thide=\'N\' order by sortby ' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        holder:res.result[k].HOLDER,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','17010','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.treeCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16532','lstseq','6','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.netCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table .warning-row  {
        color: red;
    }
    .el-table .many-row  {
        color: green;
        
    }
    .el-table .one-row  {
        color: #ffa500;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
</style>
